import { appNavigation } from "../../styles/appNavigation";
import IconHelper from "./IconHelper";

const ExpandCollapseMenuIcon = (props) => {
  const { expand, ...rest } = props;

  const color = appNavigation.drawer.icon.color;
  return expand ? (
    <IconHelper {...rest} defaultWidth={24} defaultHeight={10}>
      <path d="m0 8h10" fill={color} stroke={color} strokeWidth="1.6" />
      <path d="m0 5h10" fill={color} stroke={color} strokeWidth="1.6" />
      <path d="m0 1h10" fill={color} stroke={color} strokeWidth="1.6" />
      <path d="m14 1 4 4-4 4z" fill={color} stroke={color} strokeWidth="1.6" />
    </IconHelper>
  ) : (
    <IconHelper {...rest} defaultWidth={24} defaultHeight={10}>
      <path
        d="m18 1-4 4 4 4m-8-1h-10m10-3h-10m10-4h-10"
        fill={color}
        stroke={color}
        strokeWidth="1.6"
      />
    </IconHelper>
  );
};

export default ExpandCollapseMenuIcon;
